import React, { Component } from 'react'

import './InformationModal.scss'
import Modal from 'components/Modal'

class InformationModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isModalOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal () {
    this.setState({isModalOpen: true})
  }

  closeModal () {
    this.setState({isModalOpen: false})
  }

  render () {
    return (
      <div className='InformationModal'>
        <button className='InformationModal-button' onClick={this.openModal}>?</button>
        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal}
          contentLabel='InformationModal'>
            {this.props.children}
        </Modal>
      </div>
    )
  }
}

InformationModal.displayName = 'InformationModal'

export default InformationModal



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/InformationModal/InformationModal.js